// extracted by mini-css-extract-plugin
export var image = "_hv-1";
export var imageContainer = "_hv-0";